export default __webpack_public_path__ + "static/media/new_kingdom_4_3x.3190702c.webp";